import API_URLS from '../../constants/api-urls';
import DefaultMaterialQuery from '../../constants/graphql-default-queries/material-without-files';
import { world } from '../../languages';
import axios from '../../utils/axios';
import { toMaterialsFromGraphql } from './mappers/from-graphql';

const PROMO_MATERIALS_LIMIT = 30;

export const getPromoMaterialsForUserLandingPage = async (authorId: number) => {
    return axios
        .get(API_URLS.ELASTIC_SEARCH, {
            params: {
                author: authorId,
                limit: PROMO_MATERIALS_LIMIT,
                world
            }
        })
        .then((response) => {
            const materialsData = response?.data?.items?.materials || response?.data?.materials || [];

            return materialsData.filter((material: Material) => Number(material.price) > 0);
        })
        .catch((error) => {
            console.error('Error fetching materials:', error);
        });
};

export const getPromoMaterialsForCartPage = async (authorId: number): Promise<Material[]> => {
    const query = `query {
            materials (
                filter: {
                    and: [
                        {author_id: ${authorId}},
                        {gt: {price: 0}}
                        {world: "${world}"}
                    ]
                },
                order_by: {sort: id, order: DESC},
                pagination: {limit: ${PROMO_MATERIALS_LIMIT}}
            ) {
                 ${DefaultMaterialQuery}
              }
        }`;

    return axios
        .post(API_URLS.MATERIALS_INDEXER_QUERY, { query })
        .then((response) => {
            return toMaterialsFromGraphql(response?.data).filter((material: Material) => !material.aclId);
        })
        .catch((error) => {
            console.error('Error fetching materials:', error);

            return [];
        });
};
